"use client";

import React, { useEffect, useState } from "react";
import styles from "./Chat.module.scss";
import MessageItem from "./MessageItem";
import RobotMessageItem from "@/app/components/robot/robotMessageItem";
import useClientMessageList from "@/app/hooks/useClientMessageList";
import { useMessageStore } from "@/app/store";
import {
  ScrollToBottom,
  RobotMessage,
  RobotMessageType,
  MessageType,
} from "@/app/store/types";
import { ScrollAction, ScrollFrom } from "@/app/hooks/useReadScrollToBottom";

export default function Chat({
  handleScrollToBottom,
  containerRef,
  pageVisible,
}: {
  handleScrollToBottom: ScrollToBottom;
  containerRef: React.RefObject<HTMLDivElement | null>;
  pageVisible?: boolean;
}) {
  const { messages, newMessageList } = useClientMessageList();
  const { chatStatus, bottomReached } = useMessageStore();

  // 监听新消息，自动滚动到底部
  useEffect(() => {
    const useStatus =
      bottomReached && pageVisible
        ? ScrollAction.FORCE_TO_BOTTOM
        : ScrollAction.AUTO;
    handleScrollToBottom(useStatus, ScrollFrom.NEW_MESSAGE);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newMessageList.length, chatStatus]);

  return (
    <>
      <div className={styles.chatMessages} ref={containerRef}>
        <div className={styles.chatContainer}>
          {messages.map((msg, idx) => {
            const key = msg.id || msg.clientId || idx;
            if (msg.senderType === "robot") {
              const robotMsg = msg as RobotMessage;
              // 兼容历史数据
              const content = robotMsg.messageType
                ? msg.content
                : robotMsg.type === MessageType.AI
                  ? msg.content
                  : JSON.parse(msg.content).text || "";
              const resolvedMessageType =
                robotMsg.messageType ||
                (robotMsg.type === MessageType.AI
                  ? RobotMessageType.ROBOT_SSE_HISTORY
                  : undefined) ||
                robotMsg.type ||
                "robot_normal_reply";
              return (
                <RobotMessageItem
                  key={key}
                  msg={{
                    ...msg,
                    content,
                    messageType:
                      resolvedMessageType as RobotMessage["messageType"],
                    streaming: robotMsg.streaming ?? false,
                    robotData: robotMsg.robotData || {},
                    handleScrollToBottom,
                  }}
                />
              );
            } else {
              return msg.handyHmsOnly ? null : (
                <MessageItem key={key} msg={{ ...msg, handleScrollToBottom }} />
              );
            }
          })}
        </div>
      </div>
    </>
  );
}
